import template from './sw-cms-section-config.html.twig';

export default {
    template,

    computed: {
        hasRulesOnAllBlocks() {
            return this.section.blocks.every((block) => {
                const rule = block.extensions.swagCmsExtensionsBlockRule;

                return rule && (rule.inverted || !!rule.visibilityRuleId);
            });
        },
    },
}
